import { API_URL } from 'core/infra/environment'
import { HttpClient, type HttpClientConfig } from 'core/infra/http/HttpClient'

import { CarrierRepository } from '../infra/CarrierRepository'

export function getPreferredTrackingMethod(config?: Partial<HttpClientConfig>) {
  const httpClient = new HttpClient(API_URL)
  const repository = new CarrierRepository({ httpClient })

  return repository.getPreferredTrackingMethod(config)
}
